<template>
    <ul class="dailyOverview nowrap ws-normal-ns
    overflow-x-auto flex flex-column-ns list pa3 mt4 mt2-ns mb0">
        <DailyOverviewItem v-for="hour in hours" :key="hour.time" :hourInfo="hour" />
    </ul>
</template>

<script>
import DailyOverviewItem from '@/components/DailyOverviewItem.vue';

export default {
    name: 'DailyOverview',
    components: {
        DailyOverviewItem,
    },
    props: {
        hours: Array,
    },
};
</script>

<style lang="scss">
.dailyOverview {
    -webkit-overflow-scrolling: touch;
}
</style>
